import { FunctionComponent, memo } from 'react';
import { StoryCardThreadContent } from '../../../../services';
import { ThreadBubble } from '../../ThreadBubble';
import { UserMentionPreview } from '../../UserMentionPreview';
import { FeedCardMargin } from '../FeedCardMargin';
import { FeedCardProps } from '../model';

import classes from './FeedCardThreadCommon.module.scss';

export const FeedCardThreadCommon: FunctionComponent<FeedCardProps> = memo(({ card, chatId }) => {
  const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, mentionedUsers } = card;

  const { title } = content as StoryCardThreadContent;

  return (
    <FeedCardMargin top left right>
      <UserMentionPreview
        mentionedUsers={mentionedUsers}
        className={classes['thread-mentions']}
        openProfile
      />
      <ThreadBubble
        title={title}
        isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
        isPinnedToTopOfStory={isPinnedToTopOfStory}
        isTitleHeading={!chatId}
      />
    </FeedCardMargin>
  );
});
